import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import { EmojiEventsOutlined as TrophyIcon } from "@mui/icons-material";
import { colors, borderRadiusPx } from "../../../../../theme";
import { NoData, CommonButton } from "../../../../Components/ui";

const ResultsEmptyState = ({ onReset, hasActiveFilters = false }) => {
  return (
    <Box
      sx={{
        bgcolor: colors.dashboard.cardBg,
        borderRadius: borderRadiusPx.xl,
        border: `1px solid ${colors.dashboard.cardBorder}`,
        p: { xs: 4, md: 6 },
        textAlign: "center",
        my: 3,
      }}
    >
      <NoData
        icon={<TrophyIcon sx={{ fontSize: 36, color: colors.primary.main }} />}
        title={hasActiveFilters ? "No Matching Draw Results" : "No Completed Draws Yet !"}
        subtitle={
          hasActiveFilters
            ? "Try clearing your search query or selecting another game category to view past results."
            : "No lottery draws have been finalized yet. Once an active lottery concludes, results and winners will be published here."
        }
        paper={false}
      />
      {hasActiveFilters && onReset && (
        <Box sx={{ mt: 2 }}>
          <CommonButton
            variant="action"
            size="small"
            onClick={onReset}
            label="Reset Search Filters"
          />
        </Box>
      )}
    </Box>
  );
};

ResultsEmptyState.propTypes = {
  onReset: PropTypes.func,
  hasActiveFilters: PropTypes.bool,
};

export default ResultsEmptyState;
